/** 礼包ID */
const GIFT_ID = 387;
/** 抽奖次数礼包ID */
const LOTTERY_GIFT_ID = 405;

export default {
  state: {
    /**
     * 已获得礼包列表
     */
    ownedGifts: [],
    /**
     * 当前抽奖次数
     */
    lotteryCount: -1,
    /**
     * 收货地址
     */
    addressData: {},
    /**
     * 签到信息
     */
    signinInfo: {},
    /**
     * 邀请次数
     */
    inviteCount: 0
  },
  mutations: {
    // 设置已获得礼包列表
    SET_OWNED_GIFTS(state, data) {
      state.ownedGifts = data;
    },
    // 设置抽奖次数
    SET_LOTTERY_COUNT(state, data) {
      state.lotteryCount = +data;
    },
    // 设置收货地址
    SET_ADDRESS_DATA(state, data) {
      state.addressData = data;
    },
    // 设置签到信息
    SET_SIGNIN_INFO(state, data) {
      state.signinInfo = data;
    },
    // 设置邀请次数
    SET_INVITE_COUNT(state, data) {
      state.inviteCount = data;
    }
  },
  actions: {
    // 更新活动相关数据
    updateAppData(context, data) {
      const { extra = {} } = data;
      context.commit(
        "SET_OWNED_GIFTS",
        extra.take_award_item ? extra.take_award_item.map(el => +el) : []
      );
      context.commit("SET_LOTTERY_COUNT", extra.residue || 0);
      context.commit("SET_INVITE_COUNT", extra.invite_total || 0);
      context.commit(
        "SET_ADDRESS_DATA",
        extra.tel && extra.name && extra.address
          ? {
              tel: extra.tel || "",
              name: extra.name || "",
              address: extra.address || ""
            }
          : {}
      );
    },
    // 追加礼包数据
    setOwnedGifts(context, awardId) {
      context.commit("SET_OWNED_GIFTS", [
        ...context.getters.ownedGifts,
        +awardId
      ]);
    },
    // 设置抽奖次数
    setLotteryCount(context, data) {
      context.commit("SET_LOTTERY_COUNT", data);
    },
    // 设置收货地址
    setAddressData(context, data) {
      context.commit("SET_ADDRESS_DATA", data);
    },
    // 设置签到信息
    setSigninInfo(context, data) {
      context.commit("SET_SIGNIN_INFO", data);
    },
    // 设置邀请次数
    setInviteCount(context, data) {
      context.commit("SET_INVITE_COUNT", data);
    }
  },
  getters: {
    // 礼包ID
    giftId: () => GIFT_ID,
    // 抽奖次数礼包ID
    lotteryGiftId: () => LOTTERY_GIFT_ID,
    // 是否已领取礼包
    isGiftClaimed: (_state, getters) => getters.ownedGifts.includes(GIFT_ID),
    // 是否已领取抽奖次数礼包
    isLotteryGiftClaimed: (_state, getters) =>
      getters.ownedGifts.includes(LOTTERY_GIFT_ID),
    // 已获得礼包列表
    ownedGifts: state => state.ownedGifts,
    // 当前抽奖次数
    lotteryCount: state => state.lotteryCount,
    // 收货地址
    addressData: state => state.addressData,
    // 签到项列表
    signinList: state =>
      (state.signinInfo.sign_day_data &&
        Object.values(state.signinInfo.sign_day_data)) ||
      [],
    // 已签到天数（包含已领取的天数）
    signinDays: (_, getters) => {
      return getters.signinList.filter(
        item => item.is_sign === 1 && item.is_award === 1
      ).length;
    },
    // 今天是否已签到并完成领奖
    isSigninToday: (state, getters) => {
      const todaySigninIndex =
        state.signinInfo.today_sign === 1
          ? state.signinInfo.cycle_sign_day
          : state.signinInfo.cycle_sign_day + 1;
      const todaySigninItem = getters.signinList[todaySigninIndex - 1];
      return (
        (todaySigninItem &&
          todaySigninItem.is_sign === 1 &&
          todaySigninItem.is_award === 1) ||
        false
      );
    },
    // 完成所有签到
    isCompleteSignin: (_, getters) => getters.signinDays === 7,
    // 邀请次数
    inviteCount: state => state.inviteCount
  }
};
